<template>
    <div class="pa-4 d-flex justify-space-between" style="font-size: 26px">
        <div>รวมทั้งหมด <b>{{ $props.total }}</b> รายการ</div>
    </div>
</template>

<script>
    export default {
        name: "ExpireTotal",
        props: ['total'],
    }
</script>

<style scoped>

</style>
